export const ID = 'id';
export const NAME = 'name';
export const DESCRIPTION = 'description';
export const CONCEPTS = 'conceptIds';
export const ORIGINAL_CONCEPT = 'originalConceptId';
export const ATTACHMENTS = 'attachments';
